export enum DestinationType {
    Students = "Students",
    Classrooms = "Classrooms"
}
